import { render } from "./AdmCreatePlans.vue?vue&type=template&id=c464744e&scoped=true&ts=true"
import script from "./AdmCreatePlans.vue?vue&type=script&lang=ts"
export * from "./AdmCreatePlans.vue?vue&type=script&lang=ts"

import "./AdmCreatePlans.vue?vue&type=style&index=0&id=c464744e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c464744e"]])

export default __exports__